import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { generarImagenes } from "../../../../componentes/imprimir/GenerarImagenes";

export const ImprimirCotizacion = (cotizacion) => {
  if (!cotizacion) return;
  console.log("Objeto Cotización recibido para impresión:", cotizacion);
  const {
    id,
    Cliente,
    Empleado,
    cliente,
    empleado,
    cotizacionDetalles = [],
    subtotal = 0,
    importeImpuesto15 = 0,
    importeImpuesto18 = 0,
    impuesto15 = 0,
    impuesto18 = 0,
    exento = 0,
    totalVenta = 0,
    fecha,
    notas,
  } = cotizacion;

  const ClienteObj = Cliente || cliente;
  const EmpleadoObj = Empleado || empleado;

  const items = cotizacionDetalles;

  const clienteNombreCompleto = ClienteObj?.nombreCorto || ClienteObj?.nombreCompleto || 'Consumidor Final';
  const empresaNombre = ClienteObj?.ClienteEmpresas?.[0]?.nombre;
  const empresaRtn = ClienteObj?.ClienteEmpresas?.[0]?.rtn;

  const rtnAImprimir = ClienteObj?.rtn || empresaRtn || "";
  let nombreAImprimir = clienteNombreCompleto;

  if (rtnAImprimir && rtnAImprimir === empresaRtn && empresaNombre && empresaNombre !== "") {
    nombreAImprimir = empresaNombre;
  }

  const fechaHora = moment(fecha || new Date()).format("DD-MM-YYYY HH:mm:ss");
  const empleadoNombre = EmpleadoObj?.nombreCorto || EmpleadoObj?.nombreCompleto || 'N/A';
  const numeroDocumento = String(id || "—");

  // Utilizamos el estilo de recibo (ancho 280px)
  const html = `
    <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
        <img src=${NegocioConfig.logo} style="width:150px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
      <div style="text-align:center; margin-bottom:5px;">
          <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
        <div style="font-size: 12px;">
          RTN: ${NegocioConfig.rtn}
        </div>
        <div style="font-size: 12px;">
          ${NegocioConfig.direccion}
        </div>
        <div style="font-size: 12px;">
          Tel: ${NegocioConfig.telefono}
        </div>
      <div style="font-weight:bold; margin:5px 0; text-align: left;">COTIZACIÓN No. ${numeroDocumento}</div>
      <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
      <div style="text-align: left;"><span>Atendió:</span> ${empleadoNombre}</div>
    </div>
    <hr style="border:1px dashed black;" />
      <div><strong>Cliente:</strong> ${nombreAImprimir}</div>
      <div><strong>RTN:</strong> ${rtnAImprimir || 'N/A'}</div> 
      <hr style="border:1px dashed black;" />
      <div style="text-align: center; font-weight: bold; margin-bottom: 5px;">DETALLE DE PRODUCTOS</div>
      <div style="margin-top:5px;">
        ${items.map((item) => {
    const nombre = item.producto?.nombre || item.servicio?.nombre || "—";
    const cantidad = parseFloat(item.cantidad || 0);
    const precioUnitario = parseFloat(item.precioSinImpuesto || 0);
    const subtotalMostrado = parseFloat(item.subtotalSinImpuesto || 0);

    return `
            <div style="margin-bottom:5px;">
              <div style="font-weight:bold; font-size:13px;">${nombre}</div>
              <div style="display:flex; justify-content:space-between; font-size:12px;">
                <span>${cantidad} x ${formatoMoneda(precioUnitario)}</span>
                <span style="font-weight:bold;">${formatoMoneda(subtotalMostrado)}</span>
              </div>
            </div>`;
  }).join("")}
      </div>
      <hr style="border:1px dashed black;" />
      <div style="text-align:right;">
        <div>Subtotal: <strong>${formatoMoneda(subtotal)}</strong></div>
        <div>Importe exento: <strong>${formatoMoneda(exento)}</strong></div>
        <div>Importe 15%: <strong>${formatoMoneda(importeImpuesto15)}</strong></div>
        <div>ISV 15%: <strong>${formatoMoneda(impuesto15)}</strong></div>
        <div>Importe 18%: <strong>${formatoMoneda(importeImpuesto18)}</strong></div>
        <div>ISV 18%: <strong>${formatoMoneda(impuesto18)}</strong></div>
        
        <div style="font-size:14px; font-weight:bold; margin-top:5px;">Total: ${formatoMoneda(totalVenta)}</div>
        <div style="margin-top:4px; margin-bottom:8px; font-weight:bold; font-size:12px; text-transform:uppercase; text-align: center;">
          ${NumeroALetras(totalVenta)}
        </div>
      </div>
      
      ${notas && notas.trim() !== "" ? `
        <hr style="border:1px dashed black;" />
        <div style="margin-top: 10px; font-size: 12px; text-align: left;">
            <strong>Notas Adicionales:</strong>
            <div style="margin-top: 3px; font-size: 11px;">${notas}</div>
        </div>
      ` : ''}

    <div style="text-align:center; margin-top:20px; font-size:14px;">
        <strong>¡Gracias por cotizar con nosotros!</strong>
        <div style="margin-top: 5px; font-size: 12px;">
            Esta cotización es válida por 7 días.
        </div>
    </div>
  </div>
  `;

  ImprimirEnIframe(html, `Cotización No. ${numeroDocumento}`, '5px');
  generarImagenes(html, 'Cotización No', numeroDocumento, 70);
  //const nombrePDF = `Cotizacion_${numeroDocumento}.pdf`;
  //generarPDF(html, nombrePDF, 70);
};